import { render, staticRenderFns } from "./ship_rate_calc.vue?vue&type=template&id=6f3b4bdc&scoped=true"
import script from "./ship_rate_calc.vue?vue&type=script&lang=js"
export * from "./ship_rate_calc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b4bdc",
  null
  
)

export default component.exports